module.exports = __webpack_public_path__ + "img/faq-how-to-play-bg.9855b999.png";